module.exports = __webpack_public_path__ + "static/noticias-15-9c2138755edaefb3b2fe6e97d4aaebfa.jpg";